import { Dispatch, SetStateAction } from 'react';
import { GetPatientsBalanceResponse_PatientBalance } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { useAppScopeStore } from '@frontend/scope';
import { Table } from '@frontend/design-system';
import { useGenerateColumns } from '../../../../../hooks/use-generate-columns';
import { CollectionColumn, generateColumns } from '../../../common/generate-columns';

type DesktopListProps = {
  patients: GetPatientsBalanceResponse_PatientBalance[];
  onSelectionChange: Dispatch<SetStateAction<Record<string, boolean>>>;
  selected: Record<string, boolean>;
};

export const DesktopList = ({ patients, onSelectionChange, selected }: DesktopListProps) => {
  const { selectedLocationIds } = useAppScopeStore();
  const columns = useGenerateColumns<CollectionColumn>(generateColumns, false, undefined, {
    hideLocationNameColumn: selectedLocationIds.length === 1,
  });

  return (
    <Table
      allowMobileView={false}
      fullHeight={true}
      fullHeightConfig={{
        maxHeight: 400,
        minHeight: 300,
      }}
      //@ts-ignore-next-line
      colConfig={columns.filter((col) => col.id !== 'actions')}
      data={patients}
      hasResponsiveColWidths
      isSelectable
      uniqueRowId={(row) => row.patientId}
      rowSelectionConfig={{
        hideBulkSelection: true,
        isRowDisabled: ({ locationIds, phoneNumber }) => locationIds?.length > 1 || !phoneNumber,
        onSelectionToggle: (_selectedRows, _data, selectedIds) => {
          onSelectionChange(selectedIds);
        },
        initialState: selected,
      }}
      isPaginated
      clientPaginationConfig={{
        defaultRowsPerPage: 10,
        rowsPerPageOptions: [10, 20, 50, 100],
        showNumRowSelector: false,
        showGoToPageField: false,
      }}
    />
  );
};
